// import React, { useEffect } from "react";
// import { Link ,useLocation} from "react-router-dom";
// import Logo from "../assets/icons/logo.png";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faBars } from "@fortawesome/free-solid-svg-icons";
// import { reactLocalStorage } from "reactjs-localstorage";
// import back from "./../assets/icons/back.png";
// function Header({
//   handleClick,
//   showSideMenu,
//   homeLogo,
//   menuBar,
//   loading,
//   setshowSideMenu,
// }) {
//     const {pathname}=useLocation();
//     console.log("Pathname :::",pathname)
//   return (
   

//     <nav
//       className="navbar"
//       role="navigation"
//       aria-label="main navigation"
//       style={{ display: "flex", flexDirection: "row" }}
//     >
//       {(pathname==="/" || pathname==="/home")  ? (
//         <>
//           <div className="p-4 fixed-width" onClick={handleClick}>
//             <FontAwesomeIcon
//               icon={faBars}
//               color="white"
//               style={{ fontSize: "30px" }}
//             />
//           </div>
//           <div
//             className="navbar-brand fixed-width"
//             style={{ marginLeft: "2rem" }}
//           >
//             <div className="px-2 pb-2">
//               <img
//                 src={homeLogo ? homeLogo : Logo}
//                 alt="logo"
//                 style={{ height: "80px" }}
//                 id="center-img"
//               />
//             </div>
//           </div>
//         </>
//       ) : (
//         <>
//           <Link
//             to="/"
//             className="navitem fixed-width"
//             style={{ padding: "10px" }}
//             onClick={() => {
//               setshowSideMenu(true);
//               // changeLogo()
//             }}
//           >
//             <img src={back} alt="back to home" />
//           </Link>
//           ={" "}
//           <div
//             className="navbar-brand fixed-width"
//             style={{
//               display: "flex",
//               justifyContent: "flex-end",
//               marginLeft: "9rem",
//             }}
//           >
//             <div className="px-2 pb-2">
//               <img
//                 src={homeLogo ? homeLogo : Logo}
//                 alt="logo"
//                 style={{ height: "80px" }}
//                 id="right-img"
//               />
//             </div>
//           </div>
//         </>
//       )}
//     </nav>
//   );
// }

// export default Header;

import React, { useEffect, useState } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import Logo from "../assets/icons/logo.png";
import { reactLocalStorage } from "reactjs-localstorage";
import back from "./../assets/icons/back.png";
import Profile from "../AppComponents/Profile";
import closeIcon from "../assets/icons/menu_close_icon.svg";
import "../AppComponents/SideMenu.scss";
import {BiUser} from "react-icons/bi";
import {BiLogOut} from "react-icons/bi";
import {MdLeaderboard} from "react-icons/md";
import {BsFillQuestionCircleFill} from "react-icons/bs";
import {HiOutlineMenu} from "react-icons/hi";
function Header({ showSideMenu,sub_url, setshowSideMenu,menu_color,menuLogo,view_btn_color,homeLogo }) {
  
  const [sideMenu, setSideMenu] = useState(false);
  let { pathname } = useLocation();
  const history = useHistory();
  const [loading,setLoading]=useState(false)
  function handleSubscribe()
  {
      setLoading(true)
      window.open(sub_url, "_self")
      setSideMenu(false)
  }
  return (
    <nav
      className="navbar"
      role="navigation"
      aria-label="main navigation"
      style={{ display: "flex", flexDirection: "row" }}
    >
      {(pathname == "/" || pathname == "/home") ? (
        <>
        {  <div
            className="p-4 fixed-width"
            onClick={() => {
              console.log("Sidemenu opened");
              setSideMenu(true);
            }}
          >
            {/* <FontAwesomeIcon
              icon={faBars}
              color="white"
              style={{ fontSize: "30px" }}
            /> */}
            <HiOutlineMenu
             color="white"
             size={40}
            />
          </div>
         }
          <div
            className="navbar-brand fixed-width"
            style={{ marginLeft: "2rem" }}
          >
            <div className="px-2 pb-2">
              <img
                src={homeLogo ? homeLogo : Logo}
                alt="logo"
                style={{ height: "80px" }}
                id="center-img"
              />
            </div>
          </div>
        </>
      ) : (
        <>
          <div
            className="navitem fixed-width"
            style={{ padding: "10px" }}
            onClick={() => {
              history.goBack();
              setshowSideMenu(true);
            }}
          >
            <img src={back} alt="back to home" />
          </div>
          <div
            className="navbar-brand fixed-width"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginLeft: "9rem",
            }}
          >
            <div className="px-2 pb-2">
              <img
                src={homeLogo ? homeLogo : Logo}
                alt="logo"
                style={{ height: "80px" }}
                id="right-img"
              />
            </div>
          </div>
        </>
      )}

      {sideMenu && (
        <div className="ld-bg">
          <div
            className="sideMenu"
            style={{ background:menu_color }}
          >
            <div className="p-4 line-bottom" style={{background:view_btn_color}}>
              <div
                style={{ float: "right" }}
                onClick={() => setSideMenu(false)}
              >
                <img src={closeIcon} alt="close" />
                {/* <span className="close-btn">X</span> */}
              </div>
              <div className="display">
                <div className="" style={{ float: "left" }}>
                  <img src={menuLogo} alt="logo" />
                </div>
              </div>
            </div>
            <Link  to="/profile" className="links text-lg text-white p-4 line-bottom justifyContent" onClick={()=>setSideMenu(false)}><BiUser size={25}/><span className="link">My Profile</span></Link>
          {(!reactLocalStorage.get("msisdn") || !reactLocalStorage.get("uid") || reactLocalStorage.get("subStatus")!=='active') &&
           <Link  to="#" className="links text-lg text-white p-4 line-bottom justifyContent" onClick={handleSubscribe}
           ><BiLogOut size={25}/><span className="link">Login</span></Link>
          }
          {
            reactLocalStorage.get("subStatus")=='active' && reactLocalStorage.get("msisdn")   && reactLocalStorage.get("showUnsub")=="yes" &&
            <Link  to="/unsub" className="links text-lg text-white p-4 line-bottom justifyContent" onClick={()=>
              { 
                setSideMenu(false)}}><BiLogOut size={25}/><span className="link">Unsubscribe</span></Link>
          
          }
         
          </div>
        </div>
      )}
    </nav>
  );
}

export default Header;
